import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InputForm from '../InputForm';
import SelectForm from '../SelectForm';
import {Sketch} from '@uiw/react-color';
import VistaPreviaImagenes from './VistaPreviaImagenes';
import EditorPage from './Editor';
import usePromocionesStore from '../../store/promocionesStore';
import LabelImagen from '../LabelImagen';
import SelectMultiForm from '../SelectMultiForm';

const FormPromociones = () => {
    const navigate = useNavigate();
    const { datos, handleChange, estatus, handleSave, setHexFondo, setHexTexto, handleImagen, imagen, limpiarImagen, sucursales, handleSucursales, error } = usePromocionesStore();
    const [disabledButton, setDisabledButton] = useState(false)    
    const goBack = () => navigate(-1);
    const opcionesSucursales = [
        { value: 'ALL', label: 'Ambas sucursales' },
        ...sucursales,
    ];

    return (
        <div className="card h-100 p-0 radius-12 overflow-hidden">
            <div className="card-body p-40">
                <div className="row">
                    <div className="col-sm-8">
                        <InputForm
                            name="nombre"
                            label="Nombre Promoción"
                            datos={datos}
                            change={handleChange}
                            error={error}
                            required/>
                        <SelectMultiForm
                            col="col-sm-12"
                            datos={opcionesSucursales}
                            change={handleSucursales}
                            values={datos.sucursales}
                            isMulti={false}
                            placeholder="Selecciona dónde aplica la promoción"
                            error={error}
                            name="sucursales"
                        />
                        <InputForm
                            name="texto_uno"
                            label="Texto 1"
                            datos={datos}
                            change={handleChange}
                            error={error}
                            required/>
                        <InputForm
                            name="texto_dos"
                            label="Texto 2"
                            datos={datos}
                            change={handleChange}
                            error={error}
                            required/>
                        {
                          imagen ? (
                            <LabelImagen
                              label="Imagen de Promoción"
                              value={datos.imagen || ""}
                              quitar={limpiarImagen}
                              required
                            />
                          ) : (
                            <InputForm
                              name="imagen"
                              label="Imagen de Promoción"
                              type="file"
                              accept="image/jpeg,image/png,image/webp"
                              datos={datos}
                              change={handleImagen}
                              error={error}
                            />
                          )
                        }
                        
                        {/* <div className='col-12 d-flex justify-content-center mt-3 mb-5' >
                            <img src={datos.imagen} alt="" width={300} />
                        </div> */}

                        <div className='row'>

                            <div className='col-6 mb-3' >
                                <label style={{ textAlign: 'center', width: '100%' }}>Color Fondo</label>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Sketch
                                      color={datos.hexFondo}
                                      disableAlpha={true}
                                      presetColors={false}
                                      onChange={(color) => {
                                        setHexFondo(color.hex);
                                      }}
                                    />
                                </div>
                            </div>
                            <div className='col-6 mb-3' >
                                <label style={{ textAlign: 'center', width: '100%' }}>Color Texto</label>
                                <div style={{ display: 'flex', justifyContent: 'center' }}>
                                    <Sketch
                                      color={datos.hexTexto}
                                      disableAlpha={true}
                                      presetColors={false}
                                      onChange={(color) => {
                                          setHexTexto(color.hex);
                                      }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-switch switch-primary d-flex align-items-center gap-2 mt-5 mx-3">
                            <input
                                className="form-check-input"
                                name="esDetalle"
                                type="checkbox"
                                role="switch"
                                id="switch1"
                                defaultChecked={datos.esDetalle}
                                onChange={() => handleChange({ target: { name: 'esDetalle', value: !datos.esDetalle } })}
                            />
                            <label
                                className="form-check-label line-height-1 fw-medium text-secondary-light"
                                htmlFor="switch1"
                            >
                                Es detalle?
                            </label>
                        </div>
                    </div>
                    <VistaPreviaImagenes/>
                </div>
                { datos.esDetalle && <EditorPage name="detalle" /> }
                <div className="row mt-5">
                    <SelectForm
                        name='estatus'
                        label='Estatus'
                        datos={datos}
                        change={handleChange}
                        options={estatus}
                    />
                    <div className="d-flex align-items-center justify-content-between gap-3 mt-24">
                        <button
                            onClick={goBack}
                            type="reset"
                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                        >
                            Cancelar
                        </button>
                        <button
                            // type="submit"
                            disabled={disabledButton}
                            onClick={
                                () => {
                                    // setDisabledButton(true);
                                    handleSave();
                                }
                            }
                            className="btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                        >
                            Guardar
                        </button>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default FormPromociones;
